import { useSearchParams, Link } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";

const CONTACT = {
  email: "anna.joy.inbox@gmail.com",
  whatsappPhone: "972559116975",
};
const whatsappUrl = `https://wa.me/${CONTACT.whatsappPhone.replace(/\D/g, "")}`;

const PRESETS = {
  english: {
    gift: {
      title: "Payment successful",
      message:
        "A gift card with activation code will be sent to the email provided. The recipient can activate the pass when they register.",
      primaryLabel: "Go back",
      primaryTo: "/8march",
      showContact: true,
      contactHeading: "Questions? Contact us",
    },
    payment: {
      title: "Payment successful",
      message: "Your pass is activated. You can book classes in the schedule.",
      primaryLabel: "Go to schedule",
      primaryTo: "/schedule",
      showContact: true,
      contactHeading: "Questions? Contact us",
    },
    default: {
      title: "Done",
      message: "Operation completed successfully.",
      primaryLabel: "Back to home",
      primaryTo: "/",
      showContact: true,
      contactHeading: "Questions? Contact us",
    },
  },
  russian: {
    gift: {
      title: "Оплата прошла успешно",
      message:
        "Подарочная карта с кодом активации придёт на указанную почту. Получатель сможет активировать абонемент при регистрации.",
      primaryLabel: "Вернуться обратно",
      primaryTo: "/8march",
      showContact: true,
      contactHeading: "Вопросы? Напишите нам",
    },
    payment: {
      title: "Оплата прошла успешно",
      message: "Ваш абонемент активирован. Можете записываться на занятия в расписании.",
      primaryLabel: "Перейти к расписанию",
      primaryTo: "/schedule",
      showContact: true,
      contactHeading: "Вопросы? Напишите нам",
    },
    default: {
      title: "Готово",
      message: "Операция выполнена успешно.",
      primaryLabel: "На главную",
      primaryTo: "/",
      showContact: true,
      contactHeading: "Вопросы? Напишите нам",
    },
  },
};

export default function SuccessPage() {
  const [searchParams] = useSearchParams();
  const { language } = useAppContext();
  const lang = language === "english" ? "english" : "russian";
  const from = searchParams.get("from") || "default";
  const presetsByLang = PRESETS[lang];
  const preset = presetsByLang[from] || presetsByLang.default;

  return (
    <div className="min-h-screen flex items-center justify-center p-8 px-4 bg-gradient-to-b from-[#faf8f5] to-[#f5f0e8]">
      <div className="max-w-[28rem] w-full bg-white rounded-[1.25rem] py-8 px-8 pb-10 text-center shadow-[0_20px_40px_rgba(44,41,37,0.12)]">
        <div
          className="w-14 h-14 mx-auto mb-5 bg-green-500 text-white text-[1.75rem] font-bold leading-[3.5rem] rounded-full"
          aria-hidden="true"
        >
          ✓
        </div>
        <h1 className="text-2xl font-semibold text-[#2c2925] mb-3">{preset.title}</h1>
        <p className="text-base text-[#5c564e] leading-[1.55] mb-6">{preset.message}</p>
        <Link
          to={preset.primaryTo}
          className="inline-block w-full py-3.5 px-6 bg-[#c67b5c] text-[#faf8f5] text-base font-semibold rounded-full no-underline transition-colors duration-200 hover:bg-[#d49a82]"
        >
          {preset.primaryLabel}
        </Link>
        {preset.showContact && (
          <div className="mt-8 pt-6 border-t border-black/[0.08]">
            <p className="text-[0.9rem] text-[#5c564e] mb-3">{preset.contactHeading}</p>
            <div className="flex flex-wrap justify-center gap-3">
              <a
                href={`mailto:${CONTACT.email}`}
                className="inline-flex items-center py-2 px-4 rounded-full text-[0.9rem] font-semibold no-underline transition-colors duration-200 bg-[#f5f0e8] text-[#c67b5c] border-2 border-[#d49a82] hover:bg-[#d49a82] hover:text-[#faf8f5]"
              >
                {CONTACT.email}
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center py-2 px-4 rounded-full text-[0.9rem] font-semibold no-underline transition-colors duration-200 bg-[#25d366] text-white border-2 border-[#20bd5a] hover:bg-[#20bd5a]"
              >
                WhatsApp
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
